import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  private apiCount = 0;
  loading$ = this.loadingSubject.asObservable();

  show() {
    if (this.apiCount === 0) {
      this.loadingSubject.next(true);
    }
    this.apiCount++;
  }

  hide() {
    if (this.apiCount > 0) {
      this.apiCount--;
    }
    if (this.apiCount <= 0) {
      this.apiCount = 0;
      this.loadingSubject.next(false);
    }
  }

  /** Clears a stuck global loader when request/hide counts are out of sync. */
  reset(): void {
    this.apiCount = 0;
    this.loadingSubject.next(false);
  }
}
